import { memo } from 'react'
import TourV2InclusionSection from './TourV2InclusionSection'
import TourV2UniqueInclusionSection from './TourV2UniqueInclusionSection'
import { EmptyArray } from 'lib/array/arrayUtils'

interface Props {
  diningInclusions?: Array<App.Tours.V2OfferInclusion>
  travelInclusions?: Array<App.Tours.V2OfferInclusion>
}

function TourV2Inclusions({
  diningInclusions = EmptyArray,
  travelInclusions = EmptyArray,
}: Props) {
  const allInclusions = [...diningInclusions, ...travelInclusions]

  return <>
    {allInclusions.length === 1 && <TourV2UniqueInclusionSection inclusion={allInclusions[0]} />}
    {allInclusions.length > 1 && allInclusions.map((inclusion, index) => (
      <TourV2InclusionSection inclusion={inclusion} key={index} />
    ))}
  </>
}

export default memo(TourV2Inclusions)
